export enum DropdownMenuEvents {
  OPEN = 'open',
  CLOSE = 'close',
  CLEAR = 'clear'
}
